import { Component } from '@angular/core'

@Component({
	selector: 'app-system-login-page',
	templateUrl: './login.component.html',
})
export class LoginPage {}
